export const UPDATE_ACTIVE_TAB = 'ACCOUNTS/UPDATE_ACTIVE_TAB';
export const GET_ACCOUNT_INFO_START = 'ACCOUNTS/GET_ACCOUNT_INFO_START';
export const GET_ACCOUNT_INFO_SUCCESS = 'ACCOUNTS/GET_ACCOUNT_INFO_SUCCESS';
export const GET_ACCOUNT_INFO_ERROR = 'ACCOUNT/GET_ACCOUNT_INFO_ERROR';
export const GET_ACCOUNT_TRANSACTIONS_START = 'ACCOUNTS/GET_ACCOUNT_TRANSACTIONS_START';
export const GET_ACCOUNT_TRANSACTIONS_SUCCESS = 'ACCOUNTS/GET_ACCOUNT_TRANSACTIONS_SUCCESS';
export const GET_ACCOUNT_TRANSACTIONS_ERROR = 'ACCOUNT/GET_ACCOUNT_TRANSACTIONS_ERROR';
